import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "bf-page-header" }
const _hoisted_2 = { class: "bf-page-header__text" }
const _hoisted_3 = { class: "bf-h1" }
const _hoisted_4 = {
  key: 0,
  class: "bf-subtitle"
}
const _hoisted_5 = {
  key: 0,
  class: "bf-page-header__actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.pageTitle), 1),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}